import { Link } from "react-router-dom";

export const Footer = () => {
    return (
        <footer
            className="relative z-10 border-t border-border/70 bg-background/60 backdrop-blur"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-2 flex flex-col sm:flex-row items-center justify-between gap-1">
                <p className="text-xs text-muted-foreground leading-none">
                    © 2026{" "}
                    <span className="font-display font-semibold text-foreground">
                        Smart Solutions
                    </span>. All Rights Reserved.
                </p>

                <nav className="flex items-center gap-3 text-xs">
                    <Link
                        to="/privacy"
                        data-testid="footer-privacy-link"
                        className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                        Privacy Policy
                    </Link>

                    <span className="h-3 w-px bg-border" aria-hidden="true" />

                    <Link
                        to="/terms"
                        data-testid="footer-terms-link"
                        className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                        Terms &amp; Conditions
                    </Link>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;